/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';
import {
  clearGraphModelError,
  getErrorMessage,
  handleGraphServiceHttpError,
  setNotification
} from './graphServiceUtils';
import { buildRubricsDeletePath } from './rubricsApiPaths';

/** DELETE /graphs/:graphId/eval/:rubricId */
export default class DeleteEvaluationService extends BaseService {
  constructor() {
    super(constants.DELETE_EVALUATION, 'deleteEvaluationStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, rubricId } = payload;
    const url = buildRubricsDeletePath(graphId, rubricId);

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').delete(url, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').delete(url, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data && data.success) {
      clearGraphModelError();
      setNotification(
        data?.message
          ? { type: 'success', message: data.message }
          : { type: 'success', langMessage: 'graphEvaluation.DELETE_SUCCESS' }
      );
      Framework.getEventManager().publish(constants.DELETE_EVALUATION_SUCCESS, {
        data,
        rubricId: data.rubricId
      });
      return;
    }

    const msg = getErrorMessage(data, 'Unknown error');
    setNotification({ type: 'error', message: msg });
    Framework.getEventManager().publish(constants.DELETE_EVALUATION_ERROR, { data, message: msg });
  }

  handleError(error) {
    handleGraphServiceHttpError(error, {
      fallbackLangMessage: 'graphEvaluation.DELETE_RETRY',
      errorEvent: constants.DELETE_EVALUATION_ERROR,
      updateGraphModelError: false
    });
  }
}
